export default __webpack_public_path__ + "static/Rosteroo - Social Media Share@2x-8d9287e00f11325807e92f8068060960.png";